import { axiosInstance } from '../initialization';

import AuthService from './auth';

function complementHeader(headers) {
  if (!headers['Content-Type']) headers['Content-Type'] = 'application/json';

  const currentUrl = new URL(window.location.href);
  const firebaseToken = currentUrl.searchParams.get('firebase');
  if (firebaseToken) headers.firebase = firebaseToken;
}

async function request(method, uri, data = {}, headers = {}) {
  complementHeader(headers);

  try {
    const url = `${process.env.API_URL}${uri}`;
    const response = await axiosInstance({
      method,
      url,
      data,
      headers,
    });
    if (response && response.data) return response.data;
    return response;
  } catch (err) {
    throw err;
  }
}

async function getRest(uri, header) {
  return request('get', uri, {}, header);
}

async function postRest(uri, data, header) {
  return request('post', uri, data, header);
}

async function deleteRest(uri, data, header) {
  return request('delete', uri, data, header);
}

function authenticatedHeader(header = {}) {
  const auth = AuthService.get();
  if (auth) header.Authorization = auth.access_token;
  return header;
}

async function getAuthenticated(uri, header) {
  return request('get', uri, {}, authenticatedHeader(header));
}

async function postAuthenticated(uri, data, header) {
  return request('post', uri, data, authenticatedHeader(header));
}

async function deleteAuthenticated(uri, data, header) {
  return request('delete', uri, data, authenticatedHeader(header));
}

export default {
  getRest,
  postRest,
  deleteRest,
  getAuthenticated,
  postAuthenticated,
  deleteAuthenticated,
};
